/**
 *
 * Styles for TargetedServiceCard
 *
 */

import styled from "styled-components";
import { Accordion } from "root/libs/ui-components/src";
import { DhlText } from "@dhl-official/react-library";
import { breakpoints } from "root/libs/ui-styleguide/src";

const DHL_BUSINESS_YELLOW = "#FBBC05";

export const TargetedServiceCardWrapper = styled.div`
  position: relative;
  width: 100%;
  background-color: var(--dui-color-white-500);
  box-shadow: rgb(229, 229, 229) 0px var(--gaq-size-space-3px)
    var(--dui-size-space-4x) 0px;
  transition: ease-in-out 200ms box-shadow;
  border-radius: var(--dui-size-radius-md);
  border: var(--dui-size-width-border-sm) solid ${DHL_BUSINESS_YELLOW};

  &:before {
    border-bottom: 4.3rem solid transparent;
    border-right: 4.3rem solid ${DHL_BUSINESS_YELLOW};
    border-top: 0 solid transparent;
    content: "";
    height: 0;
    position: absolute;
    right: 0;
    width: 0;

    @media screen and (min-width: ${breakpoints.desktop}) {
      border-bottom: 7.6rem solid transparent;
      border-right: 7.6rem solid ${DHL_BUSINESS_YELLOW};
    }
  }

  > .accordion {
    width: 100%;
    margin: 0 0 var(--gaq-size-space-30px) 0;
    padding: 0;
  }

  .offerCollapsibleContent {
    margin-bottom: 0;
    padding: 0;

    &.expanded {
      padding: 2.1rem 2.1rem var(--gaq-size-space-30px) 2.1rem;
    }
  }

  &:hover {
    box-shadow: rgba(80, 80, 80, 0.7) 0px var(--gaq-size-space-3px)
      var(--dui-size-space-4x) 0px;

    .accordion {
      & > div:not(.accordionPanel) {
        button {
          box-shadow: rgba(80, 80, 80, 0.7) 0px var(--dui-size-space-4x)
            var(--gaq-size-space-5px) var(--gaq-size-space--5px);
        }
      }
    }
  }

  &:focus,
  &:focus-within {
    box-shadow: 0 2px 7px 1px var(--dui-color-gray-500);
    outline: 2px solid transparent;

    .accordion {
      & > div:not(.accordionPanel) {
        button {
          box-shadow: 0 var(--dui-size-space-4x) var(--gaq-size-space-5px)
            var(--gaq-size-space--5px) var(--dui-color-gray-500);
        }
      }
    }
  }

  @media print {
    padding: var(--dui-size-space-10x);
    page-break-after: always;
    page-break-inside: avoid;
    margin-top: var(--gaq-size-space-30px);

    & .accordion > dd {
      height: auto;
    }
  }
`;

const CardContentPaddingMobile = "20px 10px 30px";
const CardContentPaddingTablet = "30px 20px";
const CardContentPaddingDesktop = "25px 30px";

export const TargetedServiceCardContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 190px;
  padding: ${CardContentPaddingMobile};

  @media screen and (min-width: ${breakpoints.tablet}) {
    padding: ${CardContentPaddingTablet};
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0;
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    padding: ${CardContentPaddingDesktop};
  }
`;

export const IntroContent = styled.div`
  margin-bottom: var(--gaq-size-space-30px);

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin-bottom: 0;
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    width: 66%;
  }
`;

export const CreateAccountContent = styled.div`
  display: block;

  @media screen and (min-width: ${breakpoints.tablet}) {
    min-width: 280px;
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    width: 280px;
  }
`;

export const StyledAccordion = styled(Accordion)`
  position: relative;
  padding: 0;

  .accordion {
    width: 100%;

    & > div > button:focus {
      outline: 1px dotted var(--dui-color-gray-700);
    }

    & > div:not(.accordionPanel) {
      button {
        position: absolute;
        z-index: 1;
        bottom: -20px;
        background: #fff;
        box-shadow: rgb(229 229 229) 0 var(--gaq-size-space-9px)
          var(--gaq-size-space-3x) var(--gaq-size-space--5px);
        transition: ease-in-out 200ms box-shadow;
      }
    }
  }
`;

export const OfferCardDetailsContent = styled.div`
  padding-top: var(--gaq-size-space-30px);
  padding-bottom: 0;
  margin-left: var(--dui-size-space-5x);
  margin-right: var(--dui-size-space-5x);
  border-top: var(--dui-size-width-border-xs) solid var(--dui-color-gray-300);
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (min-width: ${breakpoints.tablet}) {
    padding-top: var(--gaq-size-space-35px);
    padding-bottom: 0;
    margin-left: var(--dui-size-space-10x);
    margin-right: var(--dui-size-space-10x);
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;

    > div {
      width: 50%;

      &:first-child {
        margin-right: 0;
      }
    }
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    padding-top: var(--dui-size-space-10x);
    margin-left: var(--gaq-size-space-30px);
    margin-right: var(--gaq-size-space-30px);

    > div:first-child {
      margin-right: 127px;
    }
  }
`;
export const ToolTipText = styled(DhlText)`
  display: ${(props) => (props.isParagraph ? "block" : "inline")};
  & > *:is(p, span) {
    margin-bottom: ${(props) =>
      props.isParagraph ? "var(--dui-size-space-5x)" : 0};
  }
`;

export const IntroContentWrapper = styled.div`
  order: 1;
  width: 100%;

  @media screen and (min-width: ${breakpoints.tablet}) {
    order: 2;
    padding-right: var(--gaq-size-space-30px);
  }
`;

export const IntroInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  > .icon {
    position: absolute;
    top: 2.5rem;
    right: 1.6rem;
    order: 2;
    height: 100%;
    width: 100%;
    text-align: right;
    max-width: 72px;
    align-self: flex-end;
    margin-bottom: auto;
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    flex-direction: row;
    align-items: center;

    > .icon {
      position: unset;
      top: unset;
      right: unset;
      margin-right: 30px;
      margin-bottom: 0;
      order: 1;
      text-align: left;
      height: auto;
      width: auto;
      max-width: unset;
      align-self: unset;
    }
  }
`;

export const RegularShipperText = styled(DhlText)`
  display: block;

  & > *:is(p, span) {
    color: var(--dui-color-black-500);
    margin: 0;
    margin-bottom: var(--dui-size-space-1x);
  }
`;

export const RecommendedSaveQuote = styled(DhlText)`
  display: block;

  & > *:is(p, span) {
    text-align: left;
    margin-top: 1rem;

    @media screen and (min-width: ${breakpoints.desktop}) {
      text-align: right;
    }
  }
  @media screen and (min-width: ${breakpoints.desktop}) {
    width: 22rem;
  }
`;

export const CreateAccountWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: var(--gaq-size-space-5px);
  margin-bottom: var(--gaq-size-space-15px);

  @media screen and (min-width: ${breakpoints.desktop}) {
    line-height: 24px;
    flex-direction: row;
    display: inline-flex;
    margin-bottom: var(--dui-size-space-4x);
  }
`;

export const CreateAccountHeadline = styled(DhlText)`
  display: block;
  padding-right: 9.3rem;

  @media screen and (min-width: ${breakpoints.tablet}) {
    max-width: 33.5rem;
    padding-right: 0;
  }

  & > *:is(p, span) {
    font-size: 2rem;
    line-height: 2.4rem;
    margin: 0;
    font-weight: 800;
    white-space: normal;
    color: var(--dui-color-black-500) !important;
  }
`;

export const PromotedTextWrapper = styled.div`
  display: flex;
  @media screen and (min-width: ${breakpoints.tablet}) {
    padding-right: var(--gaq-size-space-50px);
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    padding-right: 0;
    align-items: inherit;

    .icon {
      margin-top: var(--gaq-size-space-5px);
    }
  }
`;

export const PromotedText = styled(DhlText)`
  min-height: 32px;
  min-height: 11%;
  @media screen and (min-width: ${breakpoints.desktop}) {
    width: 31.5rem;
  }
  & > *:is(p, span) {
    padding-left: 1rem;
  }
`;

export const CardButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: var(--gaq-size-space-5px);

  a {
    width: 100% !important;
  }

  @media print {
    display: none;
  }
`;
